
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface TrainerInfoProps {
  trainer: {
    first_name: string;
    last_name: string;
    avatar_url?: string;
    email?: string;
    phone?: string;
  };
}

export const TrainerInfo = ({ trainer }: TrainerInfoProps) => {
  const { t } = useTranslations("student");
  
  if (!trainer) return null;

  return (
    <Card className="shadow-md border border-slate-100 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm">
      <CardContent className="p-6">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Avatar className="h-16 w-16 border-2 border-white shadow-md">
            <AvatarImage src={trainer.avatar_url} />
            <AvatarFallback className="bg-slate-100 dark:bg-gray-700 text-slate-500 dark:text-slate-300">
              {trainer.first_name?.[0]}{trainer.last_name?.[0]}
            </AvatarFallback>
          </Avatar>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-xl font-bold text-slate-900 dark:text-slate-100">
              {t("overview.trainer.yourTrainer")}
            </h3>
            <p className="text-lg font-medium text-slate-700 dark:text-slate-300">
              {trainer.first_name} {trainer.last_name}
            </p>
          </div>
          {trainer.email && (
            <Button variant="outline" className="gap-2" size="sm" asChild>
              <a href={`mailto:${trainer.email}`}>
                <Mail className="h-4 w-4" />
                <span>{t("overview.trainer.contactTrainer")}</span>
              </a>
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
